import { SinhVienService } from "../services/sinhvien.service";

var sinhvien = {
	sinhVienId: "",
	createdTime: "",
	createdBy: "",
	modifiedTime: "",
	modifiedBy: "",
	trungTuyenId: "",
	maSinhVien: "",
	maVach: "",
	lopId: "",
	khoaId: "",
	nganhId: "",
	status: "",
	lop: null,
};
var state = {
	sinhvien: { ...sinhvien },
	sinhviens: [],
};

var getters = {};

var mutations = {
	saveSinhVien(state, data) {
		state.sinhvien = data;
	},
};

var actions = {
	createSinhVien({ commit }, payload) {
		return SinhVienService.createSinhVien(payload)
			.then(async (response) => {
				if (response.status === 201)
					await commit("saveSinhVien", response.data);
				return response;
			})
			.catch((error) => error.message);
	},
};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
};
